module.exports = __webpack_public_path__ + "img/only_logo.2993dddb.png";